import { useContext } from "react";
import { HeaderContext } from "./Context";
export * from "./Context";
export { HeaderProvider } from "./Provider";
export { withHeader } from "./with";

export function useHeader() {
  return useContext(HeaderContext);
}
